export function addExtraInfoComponents(value, controller) {
  const newItems = controller.options.filter(item => {
    return value.indexOf(item.key) === -1;
  });
  const defaultSectionMap = {
    Social: 'bottom'
  };
  if (newItems.length === 0) {
    return value;
  }
  // place additional items in the top section initially
  let newVal = value;
  newItems.forEach(item => {
    newVal = newVal.replace(defaultSectionMap[item.key], defaultSectionMap[item.key] + "," + item.key);
  });
  return newVal;
}
//# sourceMappingURL=infoUtils.js.map